<template>
  <section
    :class="{
      'plans-section mt-50px lg:-mt-100px': true,
    }"
  >
    <div
      v-if="plans"
      :class="{
        'narrow-container mx-auto p-0': true,
      }"
    >
      <div
        :class="{
          'flex flex-wrap justify-center': true,
        }"
        data-testid="PlanSection"
      >
        <div
          v-for="(plan, index) in plans"
          :key="index"
          :class="{
            'mb-6 w-full px-3 md:w-1/2 xl:w-1/4': true,
          }"
        >
          <PlanItem
            v-if="plan"
            v-bind="plan"
            :class="{
              'plan-item': true,
            }"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import PlanItem from './PlanItem.vue';
import type { HighlightedPlans } from '~/sanity/types';

defineProps<HighlightedPlans>();
</script>
